import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_CALL_PROFILE_STICKY_COLUMNS,
  UPDATE_CALL_PROFILE_STICKY_COLUMNS,
} from "./actionTypes"

import {
  getCallProfileStickyColumnsSuccess,
  getCallProfileStickyColumnsError,
  updateCallProfileStickyColumnsSuccess,
  updateCallProfileStickyColumnsError
} from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"

function* ongetCallProfileStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_call_profiles`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCallProfileStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getCallProfileStickyColumnsError(error))
  }
}

function* onupdateCallProfileStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_column_preference_call_profiles/${action?.payload?.user_column_preference_profile?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCallProfileStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateCallProfileStickyColumnsError(error))
  }
}

function* userCallProfileColumnPreferenceSaga() {
  yield takeEvery(GET_CALL_PROFILE_STICKY_COLUMNS, ongetCallProfileStickyColumns)
  yield takeEvery(UPDATE_CALL_PROFILE_STICKY_COLUMNS, onupdateCallProfileStickyColumns)
}

export default userCallProfileColumnPreferenceSaga;
